<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>会社情報</v-card-title>
      <v-card-text>
        {{value}}
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex md10>
              <v-text-field v-model="value.name" label="会社名" required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md4>
              <v-select v-model="value.staffs" label="社員数" :items="staffsOptions" required></v-select>
            </v-flex>
            <v-flex md4>
              <v-text-field v-model="value.years" label="創業年（西暦）" type="number" required></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md2>
              <v-select v-model="value.listed" label="上場・非上場" :items="listedOptions" required></v-select>
            </v-flex>
            <v-flex md6>
              <v-text-field
                v-model="value.classification"
                label="業種分類"
                @click.stop="dialog=true"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">キャンセル</v-btn>
        <v-btn v-if="action == 'add'" @click="addItem">追加</v-btn>
        <v-btn v-if="action == 'update'" @click="updateItem">更新</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialog" fullscreen>
      <v-card tile>
        <v-toolbar card color="indigo" class="white--text" dark>
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>業種選択</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex md4>
                <v-text-field v-model="search" label="検索"></v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              class="elevation-1"
              :pagination.sync="pagination"
              rows-per-page-text="表示行"
              :rows-per-page-items="rowsPerPageItems"
            >
              <template slot="items" slot-scope="props">
                <tr @click.stop="selectWork(props.item)">
                  <td class="text-xs-left">{{ props.item.id }}</td>
                  <td class="text-xs-left">{{ props.item.category }}</td>
                  <td class="text-xs-left">{{ props.item.subcategory }}</td>
                  <td class="text-xs-left">{{ props.item.subsubcategory }}</td>
                  <td class="text-xs-left">{{ props.item.name }}</td>
                </tr>
              </template>
              <template
                slot="pageText"
                slot-scope="props"
              >{{ props.itemsLength }} 件中 {{ props.pageStart }} - {{ props.pageStop }} 件表示</template>
            </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import works from "./works.json";
export default {
  components: {},
  props: ["value", "action"],
  data() {
    return {
      search: "",
      dialog: false,
      items: [],
      headers: [
        {
          text: "コード",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "大分類",
          align: "left",
          sortable: false,
          value: "category"
        },
        {
          text: "中分類",
          align: "left",
          sortable: false,
          value: "subcategory"
        },
        {
          text: "小分類",
          align: "left",
          sortable: false,
          value: "subsubcategory"
        },
        {
          text: "業種名",
          align: "left",
          sortable: false,
          value: "name"
        }
      ],
      file: null,
      pagination: {
        rowsPerPage: 50
      },
      rowsPerPageItems: [25, 50, 100],
      search: "",
      staffsOptions: [
        { value: 1, text: "5人未満" },
        { value: 2, text: "5～ 29人" },
        { value: 3, text: "30～ 99人" },
        { value: 4, text: "100～299人" },
        { value: 5, text: "300～999人" },
        { value: 6, text: "1,000人以上" }
      ],
      listedOptions: ["非上場", "上場"],
      classificationOptions: [
        { value: 1, text: "鉱業，採石業，砂利採取業" },
        { value: 2, text: "建設業" },
        { value: 3, text: "製造業" },
        { value: 4, text: "電気･ガス･熱供給･水道業 " },
        { value: 5, text: "情報通信業" },
        { value: 6, text: "運輸業，郵便業" },
        { value: 7, text: "卸売業，小売業" },
        { value: 8, text: "金融業，保険業" },
        { value: 9, text: "不動産業，物品賃貸業" },
        { value: 10, text: "学術研究，専門･技術サ－ビス業" },
        { value: 11, text: "宿泊業，飲食サ－ビス業" },
        { value: 12, text: "生活関連サ－ビス業，娯楽業" },
        { value: 13, text: "教育，学習支援業" },
        { value: 14, text: "医療，福祉" },
        { value: 15, text: "サービス業(他に分類されないもの)" }
      ]
    };
  },
  watch: {},
  mounted() {
    this.items = works;
  },
  computed: {},
  methods: {
    close() {
      this.$emit("closeDialog");
    },
    addItem() {
      this.$emit("createItem");
    },
    updateItem() {
      this.$emit("updateItem");
    },
    selectWork(work) {
      this.value.classification = work.name;
      this.value.classification_id = work.id;
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
